import React from 'react'
import { Divider } from 'semantic-ui-react'

import { defaultStyles as styles } from '../styles'

export const OverviewTab = () => {
  return (
    <>
      <p style={styles.sectionTitle}>Biography</p>
      <span style={styles.contentText}>&quot;It is important to me that my patients feel heard. I enjoy helping them reach their health goals and being their partner in the decision-making process. In my spare time, I enjoy learning new recipes, exercising, poetry, and spending time visiting with family.&quot;</span>
      <Divider />
      <div style={styles.flexBox}>
        <div style={styles.flexBoxBasis(150)}>
          <p style={styles.sectionTitle}>Specialties</p>
          <ul style={styles.contentItem}>
            <li>Primary Care</li>
            <li>Family Medicine</li>
          </ul>
        </div>
        <div style={styles.flexBoxBasis(150)}>
          <p style={styles.sectionTitle}>Gender</p>
          <ul style={styles.contentItem}>
            <li>Male</li>
          </ul>
        </div>
      </div>

      <div style={styles.flexBox}>
        <div style={styles.flexBoxBasis(150)}>
          <p style={styles.sectionTitle}>Age groups seen</p>
          <ul style={styles.contentItem}>
            <li>Pediatrics</li>
            <li>Teenagers</li>
            <li>Adults</li>
            <li>Geriatrics</li>
          </ul>
        </div>

        <div style={styles.flexBoxBasis(150)}>
          <p style={styles.sectionTitle}>Languages</p>
          <ul style={styles.contentItem}>
            <li>English</li>
            <li>Mandarine Chinese</li>
            <li>Korean</li>
          </ul>
        </div>
      </div>
    </>
  )
}
